module.exports = __webpack_public_path__ + "img/live-logo.5f09294f.gif";